// Mục "Chi phí & nợ Xu": Xu đang lưu hành quy ra tiền, Xu chờ mở khoá, Xu thu hồi/hết hạn + Top 10 người nhận nhiều Xu.
import { Button, Card, Col, Row, Table } from "antd";
import { faCoins, faHourglassHalf, faRotateLeft, faScaleBalanced } from "@fortawesome/free-solid-svg-icons";
import XuKpiCard from "./xu-kpi-card";
import { fmtNum, fmtVndFromXu } from "./xu-format-helpers";

export default function XuStatsCostSection({ cost, onOpenUser }) {
    const { inRange } = cost;
    const columns = [
        { title: "#", width: 40, render: (_, __, i) => i + 1 },
        { title: "Người dùng", render: (_, r) => <Button type="link" size="small" className="!p-0" onClick={() => onOpenUser(r.userId)}>{r.name || "(chưa đặt tên)"} #{r.userId}</Button> },
        { title: "Xu nhận", dataIndex: "xu", align: "right", render: fmtNum },
        { title: "≈ tiền", dataIndex: "xu", align: "right", render: fmtVndFromXu },
    ];
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={14}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}><XuKpiCard icon={faScaleBalanced} tone="rose" title="Xu đang lưu hành (nợ phải trả)" value={fmtNum(cost.circulating)} unit="Xu"
                        sub={`≈ ${fmtNum(cost.circulatingVnd)}đ (2 Xu = 1đ)${cost.debt ? ` · nợ Xu ${fmtNum(cost.debt)}` : ""}`} help="Tổng số dư của mọi ví. Đây là phần tối đa LH có thể phải chi nếu mọi người đổi hết." /></Col>
                    <Col xs={24} sm={12}><XuKpiCard icon={faHourglassHalf} tone="slate" title="Xu chờ mở khoá" value={fmtNum(cost.pending.xu)} unit="Xu"
                        sub={`${fmtNum(cost.pending.users)} khoản · ≈ ${fmtNum(cost.pending.vnd)}đ`} help="Thưởng lớn của tài khoản mới chưa có đơn duyệt; phát khi có đơn đầu tiên, quá hạn thì huỷ." /></Col>
                    <Col xs={24} sm={12}><XuKpiCard icon={faCoins} tone="amber" title="Xu đã phát trong khoảng" value={fmtNum(inRange.earned)} unit="Xu"
                        sub={`≈ ${fmtNum(Math.floor(inRange.earned / 2))}đ`} /></Col>
                    <Col xs={24} sm={12}><XuKpiCard icon={faRotateLeft} tone="purple" title="Xu thu hồi / hết hạn" value={fmtNum(inRange.revoked + inRange.expired)} unit="Xu"
                        sub={`Thu hồi ${fmtNum(inRange.revoked)} · Hết hạn ${fmtNum(inRange.expired)}${inRange.adjusted ? ` · Admin chỉnh ${fmtNum(inRange.adjusted)}` : ""}`} /></Col>
                </Row>
            </Col>
            <Col xs={24} lg={10}>
                <Card size="small" title="Top 10 người nhận nhiều Xu nhất" className="shadow-sm h-full">
                    <Table size="small" rowKey="userId" pagination={false} columns={columns} dataSource={cost.topEarners} scroll={{ x: "max-content" }}
                        locale={{ emptyText: "Chưa có ai nhận Xu trong khoảng này" }} />
                </Card>
            </Col>
        </Row>
    );
}
